import {
  baseAPIRequest,
  httpRequestMethods
} from '@/axios_init_p'

export function login (data) {
  return baseAPIRequest('login', httpRequestMethods.POST, data)
}

export function user (data) {
  return baseAPIRequest('user', httpRequestMethods.POST, data)
}

export function inputData (data) {
  return baseAPIRequest('input_data', httpRequestMethods.POST, data)
}

export function inputAllData (data) {
  return baseAPIRequest('input_all_data', httpRequestMethods.POST, data)
}

export function orderPlant (data) {
  return baseAPIRequest('order_plant', httpRequestMethods.POST, data)
}

export function getInvoicingTodayData (parm) {
  return baseAPIRequest('invoicing', httpRequestMethods.GET, parm)
}

export function updateInvoicingData (data) {
  return baseAPIRequest('invoicing', httpRequestMethods.POST, data)
}

export function predictionData () {
  return baseAPIRequest('prediction_data', httpRequestMethods.GET)
}

export function assignOrder (data) {
  return baseAPIRequest('order', httpRequestMethods.POST, data)
}

export function getCarOrder () {
  return baseAPIRequest('order', httpRequestMethods.GET)
}

export function getStatus (data) {
  return baseAPIRequest('redis_data', httpRequestMethods.POST, data)
}

export function depot (data) {
  return baseAPIRequest('depot', httpRequestMethods.POST, data)
}

export function driver (data) {
  return baseAPIRequest('driver', httpRequestMethods.POST, data)
}

export function car (data) {
  return baseAPIRequest('car', httpRequestMethods.POST, data)
}

export function gas (data) {
  return baseAPIRequest('gas', httpRequestMethods.POST, data)
}

export function depotValume (data) {
  return baseAPIRequest('depot_valume', httpRequestMethods.POST, data)
}



// WEBPACK FOOTER //
// ./src/api/oli_api.js